export const setTimezone = timezone => ({
  type: 'SET_TIMEZONE',
  payload: timezone,
});
